import { useSmartLinkContext } from './state/context';
export function useFeatureFlag(featureFlag) {
  var _context$featureFlags;
  var context = useSmartLinkContext();
  return (context === null || context === void 0 ? void 0 : context.featureFlags) && (context === null || context === void 0 || (_context$featureFlags = context.featureFlags) === null || _context$featureFlags === void 0 ? void 0 : _context$featureFlags[featureFlag]);
}